export class Language {
  code: string;
  isActive: boolean;
  isActiveOnWIMS: boolean;
  modifyDate: Date;
  name: string;
  isRenaming: boolean;
  isItemLoading: boolean;

  constructor(code: string, name: string) {
    this.code = code;
    this.name = name;
  }
}

export class LocalizationInStorage {
  modified: Date;
  value: Record<string, string>;

  constructor(modified: Date, localization: Record<string, string>) {
    this.modified = modified;
    this.value = localization;
  }
}

export interface LocalizationListWitDefaultLanguageDto {
  defaultLanguage: Record<string, string>;
  language: Record<string, string>;
}
